import React from 'react'
import { Form, Field, reduxForm, SubmissionError } from 'redux-form'
import * as MabnaButton from '../common/Button/Button'
import { RESET_PASS_REQUEST } from '../../actions/actions'
import { PulseLoader } from 'halogen'
import { appendToFormData } from '../../helpers/utility'
import { browserHistory } from 'react-router'

const styles = {
  spinner: {
    height: 45,
    margin: '20px 0',
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
}

class ResetPassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      emailSubmitted: false,
      emailAddress: '',
    }
  }

  onSubmit = values => {
    const { dispatch } = this.props
    const formData = appendToFormData(values)

    return new Promise((resolve, reject) => {
      dispatch({ type: RESET_PASS_REQUEST, formData, resolve, reject })
    })
      .then(() => this.setState({ emailSubmitted: true, emailAddress: values.email }))
      .catch(({ form_errors, general_errors }) => {
        throw new SubmissionError({ ...form_errors, _error: general_errors })
      })
  }

  emailInput = ({ input, meta: { touched, error } }) => {
    let hasError = touched && error !== undefined
    return (
      <div className="reset-pass">
        <div className="form-error">{hasError && error}</div>
        <input type="text" className="border-focus-blue" placeholder="ایمیل" {...input} />
      </div>
    )
  }

  render() {
    const { handleSubmit, error } = this.props
    return (
      <div id="signup-success">
        <div
          className="text-center bg-darkblue fg-white"
          style={{ flex: 1, marginBottom: 10 }}
        >
          <h4 style={{ margin: 0, padding: 10 }}>بازیابی گذرواژه</h4>
        </div>

        {!this.state.emailSubmitted && (
          <div>
            <h4>
              برای بازیابی گذرواژه لطفا ایمیل خود را که قبلا در سامانه ثبت کرده اید وارد
              کنید
            </h4>
          </div>
        )}

        {!this.state.emailSubmitted ? (
          <Form onSubmit={handleSubmit(this.onSubmit)}>
            <div className="form-error">{error && error}</div>
            <Field name="email" component={this.emailInput} />
            <MabnaButton.Primary
              outline
              onClick={() => browserHistory.push('/')}
            >
              بازگشت
            </MabnaButton.Primary>
            {!this.props.aSyncCall ? (
              <MabnaButton.Primary type="submit">
                بازیابی گذرواژه
              </MabnaButton.Primary>
            ) : (
              <div style={styles.spinner}>
                <PulseLoader color="#275C8A" size="10px" />
              </div>
            )}
          </Form>
        ) : (
          <div>
            <h4>یک ایمیل حاوی لینک بازیابی رمز عبور به ایمیل زیر ارسال شد</h4>
            <h5>{this.state.emailAddress}</h5>
            <h5>در صورت عدم دریافت ایمیل لطفا پوشه اسپم را نیز بررسی کنید</h5>
            <MabnaButton.Primary
              outline
              onClick={() => browserHistory.push('/')}
            >
              بازگشت
            </MabnaButton.Primary>
          </div>
        )}
      </div>
    )
  }
}

const validate = values => {
  let validEmail = /\S+@\S+\.\S+/
  let errors = {}

  if (!values.email) {
    errors.email = 'لطفا ایمیل خود را وارد کنید'
  }

  if (values.email) {
    if (!validEmail.test(values.email)) {
      errors.email = 'لطفا یک ایمیل معتبر وارد کنید'
    }
  }

  return errors
}

ResetPassword = reduxForm({
  form: 'resetPassword',
  validate,
})(ResetPassword)

export default ResetPassword



// WEBPACK FOOTER //
// ./src/components/authentication/ResetPasswordByEmail.js